import { MonoBehavior } from './core/monoBehavior';
import { SolitaireGame } from './SolitaireGame';
import { DifficultyLevelType, GameName } from 'constants/difficulty';
import { registerCustomEvents } from './gameEventsActions';
import { setLanguage } from './translate';
import { Store } from './store/gameStore';
import { GameEvent } from './events/gameEvent';
import { EventName } from './events/eventsName';
import { GAEvent, GAEventNames } from './analytics/events';
import { GameUI } from './gameUI/GameUI';
import { AdsManager } from './gameUI/AdsManager';
import { createGameButtons } from './gameUI/GameActionButtons';
import { getRandomDifficultyId } from './deals';

export class PlayableLevel extends MonoBehavior {
    level?: SolitaireGame;
    levelId = '';

    constructor() {
        super();
        this.startGame = this.startGame.bind(this);
        this.restartLevel = this.restartLevel.bind(this);
        this.newLevel = this.newLevel.bind(this);
        this.newWinLevel = this.newWinLevel.bind(this);
        this.onNewGameEvent = this.onNewGameEvent.bind(this);
        this.newDeal = this.newDeal.bind(this);
        registerCustomEvents();
    }

    start(): void {
        this.startGame();

        addEventListener('newGame', this.onNewGameEvent, false);
        addEventListener('newWinGame', this.newWinLevel, false);
        addEventListener('dealId', this.newDeal, false);
        addEventListener('restartGame', this.restartLevel, false);
        addEventListener('changeLanguage', this.changeLanguage, false);
        addEventListener('newGameButton', this.logOpenNewGamePopup, false);
        addEventListener('open-popup', (e: CustomEvent) => {
            GameEvent.emit(EventName.BLOCK_KEYBOARD);
        });
        addEventListener('openedModal', (e: CustomEvent) => {
            GameEvent.emit(EventName.OPEN_MODAL, e.detail);
            GameEvent.emit(EventName.BLOCK_KEYBOARD);
        });
    }

    changeLanguage(e: { detail: { lang: string } }) {
        setLanguage(e.detail.lang);
    }
    logOpenNewGamePopup() {
        GAEvent(GAEventNames.OPEN_NEW_GAME_POPUP, {
            type: Store.getGameTypeText(),
            difficulty: Store.getDifficultyText(),
        });
    }
    startGame() {
        this.level = new SolitaireGame();
        const gameUi = new GameUI();
        createGameButtons();

        
        this.newLevel(true);

        if (this.level.gameStrategy && !this.level.gameStrategy.IsShowDifficultyUI) {
            gameUi.removeDifficulty();
        }

        new AdsManager();
    }
    newDeal(e: { detail: { id: string } }) {
        if (!this.level) {
            return;
        }
        this.level.newGameById(e.detail.id);
    }
    async onNewGameEvent(
        e: { detail: { difficulty?: DifficultyLevelType; deal?: string; name?: GameName; suits?: string } } | null
    ) {
        let difficulty = e?.detail?.difficulty as DifficultyLevelType;
        let balanced = false;
        if (Store.tutorialActive) {
            Store.setTutorialActive(false);
        }
        if (difficulty && difficulty.includes('BALANCED')) {
            Store.difficultyBalancedIndex++;
            difficulty = Store.getBalancedDifficulty();
            balanced = true;
        }

        if (difficulty) Store.setDifficulty(difficulty, balanced);

        const newId = await getRandomDifficultyId(Store.difficulty);
        Store.gameId = newId;
        this.newLevel(false, false);
    }

    async newWinLevel() {
        if (Store.difficultyBalanced) {
            Store.difficultyBalancedIndex++;
            Store.gameStorage.setItem('difficultyBalancedIndex', Store.difficultyBalancedIndex);
            const difficulty = Store.getBalancedDifficulty();
            Store.setDifficulty(difficulty, true);
        }
        const newId = await getRandomDifficultyId(Store.difficulty);
        Store.gameId = newId;
        this.newLevel(false, true);
    }
    newLevel(onRefresh = false, winPopup = false) {
        GameEvent.emit(EventName.SET_HINT_DISABLED, true);
        GameEvent.emit(EventName.SET_WAND_DISABLED, true);
        GameEvent.emit(EventName.SET_UNDO_DISABLED, true);

        if (!this.level) return;

        this.levelId = this.level.newGame(Store.difficulty, onRefresh, winPopup);
    }
    restartLevel(e: CustomEvent) {
        GameEvent.emit(EventName.SHOW_GAME);
        if (!this.level) return;
        if (this.levelId === '') return;
        const timeBeforeReset = Store.time;

        this.level.newGameById(this.levelId); //easy , medium, hard?
        Store.attempts++;
        GAEvent(GAEventNames.GAME_RESTART, {
            id: Store.gameId,
            type: Store.getGameTypeText(),
            difficulty: Store.getDifficultyText(),
            timeSec: timeBeforeReset,
        });
    }
}
